import { render, staticRenderFns } from "./DetailTicket.vue?vue&type=template&id=e1de75fc&scoped=true"
import script from "./DetailTicket.vue?vue&type=script&lang=js"
export * from "./DetailTicket.vue?vue&type=script&lang=js"
import style0 from "./DetailTicket.vue?vue&type=style&index=0&id=e1de75fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1de75fc",
  null
  
)

export default component.exports